export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-24 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-6 whitespace-nowrap">
              <i className="ri-flashlight-line text-sm"></i>
              <span>实时更新 · 防封防失效 · 永久收藏</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-950 mb-5">
              91樱花
              <span className="block text-primary-600 mt-1">你的动漫追番专属入口</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 mb-4">
              91樱花致力于为广大动漫爱好者提供最新网址与最新入口，实时更新新地址，全方位防封防失效，确保当前网址始终可用。
            </p>
            <p className="text-base md:text-lg text-foreground-500 mb-8">
              无论你是在追新番还是补经典，91樱花都能让你一键直达动漫内容，方便永久收藏并快速访问。本站持续跟踪域名变动，第一时间推送最新入口，让你永不掉队。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-500 text-xl"></i>
                <span className="text-sm text-foreground-600">实时地址监测</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-refresh-line text-accent-500 text-xl"></i>
                <span className="text-sm text-foreground-600">每日自动更新</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-heart-line text-primary-400 text-xl"></i>
                <span className="text-sm text-foreground-600">数万漫迷信赖</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-rocket-line"></i>
                查看最新快讯
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 border border-primary-300 text-primary-600 rounded-full font-medium text-sm hover:bg-primary-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line"></i>
                热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] md:w-[420px] md:h-[420px] lg:w-[480px] lg:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Dreamy%20anime%20art%20illustration%20of%20cherry%20blossom%20trees%20in%20full%20bloom%20with%20soft%20pink%20petals%20dancing%20in%20golden%20sunlight%2C%20Japanese%20temple%20gate%20silhouette%20in%20background%2C%20ethereal%20warm%20atmosphere%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20dreamy%20soft%20focus%2C%20anime%20movie%20poster%20quality%2C%20cinematic%20composition%2C%20floating%20sparkles%20and%20light%20particles%2C%20beautiful%20spring%20scene%2C%20Japanese%20aesthetic%2C%20high%20detail%20digital%20illustration&width=960&height=960&seq=91sakura-hero-main&orientation=squarish"
                alt="91樱花 - 动漫追番入口主视觉"
                className="w-full h-full object-cover rounded-2xl"
                title="91樱花最新网址与最新入口主视觉"
              />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 bg-accent-200/60 rounded-2xl -z-10"></div>
              <div className="absolute -top-3 -left-3 w-16 h-16 md:w-20 md:h-20 bg-primary-200/60 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}